module.exports = __webpack_public_path__ + "img/AuctionVintageCar300x300.2ba70d71.jpg";